import { defineStore } from 'pinia'
import req from '@/api/httpRequest'
import { computed } from 'vue'

export const useTicketStore = defineStore('ticketStore', () => {
  const ticket = ref({})
  const ticketActions = computed(() => ticket.value.actions)

  const ticketCommentsExternal = ref([])
  const ticketCommentsInternal = ref([])

  const ticketPriorityOptions = ref([])

  const ticketOwnerOptions = ref([])

  const ticketStateOptions = ref([])

  async function fetchTicketDetails(ticketId) {
    const requestBody = {
      headers: {},
      requestParam: { id: ticketId },
    }

    // console.log('Sending request with body:', JSON.stringify(requestBody, null, 2));

    const { data } = await req.post('tickets/item', requestBody)

    if (data.data) {
      ticket.value = data.data
    }
  }

  async function fetchTicketDetailsShort(ticketId) {
    const { data } = await req.post('tickets/item/short', { headers: {}, requestParam: { id: ticketId } })
    if (data.data) {
      ticket.value = data.data
    }
  }

  async function fetchTicketExternalComments() {
    const { data } = await req.post('tickets/item/messages', {
      headers: {},
      requestParam: { id: ticket.value.id },
    })

    if (data.data) {
      ticketCommentsExternal.value = data.data
    }
  }

  async function fetchTicketInternalComments() {
    const { data } = await req.post('tickets/item/comments', {
      headers: {},
      requestParam: { id: ticket.value.id },
    })

    if (data.data) {
      ticketCommentsInternal.value = data.data
    }
  }

  async function submitExternalComment(newComment) {
    const formDataToSend = new FormData()
    formDataToSend.append('action', 3) // 3 for external comment
    formDataToSend.append('text', newComment.text)
    formDataToSend.append('ticket', ticket.value.id)
    newComment.files.forEach((file) => {
      formDataToSend.append('files', file)
    })

    const { data } = await req.post('tickets/messages/create', {
      headers: { 'Content-Type': 'multipart/form-data' },
      requestParam: formDataToSend,
    })

    if (data.id) {
      return data
    }
  }

  async function submitInternalComment(newComment) {
    const formDataToSend = new FormData()
    formDataToSend.append('text', newComment.text)
    formDataToSend.append('action', 2) // 2 for internal comment
    formDataToSend.append('ticket', ticket.value.id)
    newComment.files.forEach((file) => {
      formDataToSend.append('files', file)
    })

    const { data } = await req.post('tickets/messages/create', {
      headers: { 'Content-Type': 'multipart/form-data' },
      requestParam: formDataToSend,
    })

    if (data.id) {
      return data
    }
  }

  async function fetchTicketPriorityOptions() {
    const { data } = await req.post('tickets/dicts/tickets/priorities', {
      headers: {},
      requestParam: {},
    })

    if (data.data) {
      ticketPriorityOptions.value = data.data
    }
  }

  async function submitTicketPriorityChange(ticketCurrentPrio, ticketPrioChangeText) {
    const { data } = await req.post(
      'tickets/item/priority/set',
      {
        headers: {},
        requestParam: {
          ticket_id: ticket.value.id,
          prio_id: ticketCurrentPrio,
          text: ticketPrioChangeText,
        },
      },
    )

    if (data) {
      return data
    }
  }

  async function fetchTicketOwnerOptions(searchQuery) {
    const { data } = await req.post('tickets/dicts/persons', { headers: {}, requestParam: { search: searchQuery } })

    if (data.data) {
      // ticketOwnerOptions.value = [...data.data, { id: 0, name: 'Не назначен' }];
      ticketOwnerOptions.value = data.data
    }
  }

  async function submitTicketOwnerChange(ticketCurrentOwnerId, ticketOwnerChangeText) {
    const { data } = await req.post('tickets/item/owner/set', { headers: {}, requestParam: {
      ticket_id: ticket.value.id,
      owner_id: ticketCurrentOwnerId,
      text: ticketOwnerChangeText,
    } })

    if (data) {
      return data
    }
  }

  async function fetchTicketStateOptions() {
    const { data } = await req.post('tickets/item/actions/states/getlist', {
      headers: {},
      requestParam: { id: ticket.value.id },
    })

    if (data.data) {
      ticketStateOptions.value = data.data
    }
  }

  async function submitTicketStateChange(ticketCurrentState, ticketStateChangeText) {
    const { data } = await req.post('tickets/item/state/set', { headers: {}, requestParam: {
      ticket_id: ticket.value.id,
      action_id: ticketCurrentState,
      text: ticketStateChangeText,
    } })

    if (data.code === 20) {
      return data
    }
  }

  return {
    ticket,
    ticketActions,
    fetchTicketDetails, // old
    fetchTicketDetailsShort,

    ticketCommentsExternal,
    ticketCommentsInternal,
    fetchTicketExternalComments,
    fetchTicketInternalComments,
    submitExternalComment,
    submitInternalComment,

    ticketPriorityOptions,
    fetchTicketPriorityOptions,
    submitTicketPriorityChange,

    ticketOwnerOptions,
    fetchTicketOwnerOptions,
    submitTicketOwnerChange,

    ticketStateOptions,
    fetchTicketStateOptions,
    submitTicketStateChange,
  }
})
